import styled from 'styled-components';

const HeroOverlapStyles = styled.section`
  position: relative;
  overflow: hidden;
  background-color: ${props => props.backgroundColor};

  @media (min-width: ${props => props.theme.breakpoints.tablet}) {
    padding: 15.875rem ${props => props.theme.padding.inner} 2rem;
  }

  @media (min-width: ${props => props.theme.breakpoints.desktop}) {
    padding: ${props =>
      props.position !== 'full'
        ? `3.44rem ${props.theme.padding.inner} 2rem`
        : `16.625rem ${props.theme.padding.inner} 2rem`};
  }

  .inner {
    position: relative;
    z-index: 0;
    max-width: ${props => props.theme.maxWidths.heroOverlapTablet};
    margin: auto;
    display: flex;
    flex-direction: row;
    justify-content: ${props =>
      props.position !== 'full'
        ? props.position == 'left'
          ? 'flex-start'
          : 'flex-end'
        : 'stretch'};

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props =>
        props.position !== 'full'
          ? props.theme.maxWidths.container
          : props.theme.maxWidths.heroOverlapFull};
    }

    h1 {
      color: ${props => props.theme.colors.claytonBlue};
      font-size: ${props => props.theme.type.large};
      line-height: ${props => props.theme.lineHeights.large};
      letter-spacing: ${props => props.theme.letterSpacing.large};
      margin: 0;
      margin-bottom: 1.6875rem;

      @media (max-width: ${props => props.theme.breakpoints.tablet}) {
        font-size: ${props => props.theme.type.largeMobile};
        line-height: ${props => props.theme.lineHeights.largeMobile};
      }
    }

    p {
      margin-top: 0;
    }

    a {
      margin-right: auto;

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        margin: ${props => (props.position === 'full' ? 'auto' : '')};
      }
    }

    .card {
      padding: 3.4375rem ${props => props.theme.padding.inner};
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      text-align: left;
      width: 100%;
      box-shadow: ${props => props.theme.shadows.mid};
      margin-bottom: 1.5rem;
      max-width: ${props =>
        props.position !== 'full' ? props.theme.maxWidths.heroOverlap : '100%'};

      @media (prefers-reduced-motion: no-preference) {
        .isAnimated& {
          opacity: 0;
          transform: scale(1.1);
          transition: all 0.4s ease-in-out;
          transition-delay: 0.2s;
        }
      }

      .active& {
        opacity: 1;
        transform: none;
      }

      p,
      h1 {
        width: 100%;
      }

      .button-link {
        line-height: 1.1em;
      }

      .links {
        margin-top: 0.75rem;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        > * {
          margin-left: 1rem;
          margin-bottom: 1rem;

          &:first-child {
            margin-left: 0;
          }
        }
      }

      @media (min-width: ${props => props.theme.breakpoints.tablet}) {
        padding: 3.4375rem 3.75rem 4.4375rem;
        width: 100%;
        align-items: left;
        text-align: left;
      }

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        padding: 4.44rem 6.625rem;
        text-align: ${props => (props.position !== 'full' ? 'left' : 'center')};
        align-items: ${props =>
          props.position !== 'full' ? 'flex-start' : 'center'};
      }
    }
  }

  .backdrop {
    display: block;
    position: relative;
    max-height: ${props => props.theme.maxHeights.heroOverlapBackdrop};
    background: ${props => props.theme.colors.vmfBlue};
    z-index: 0;
    padding: 0;
    margin: 0;
    height: ${props => props.theme.heights.heroOverlapBackdropMobile};

    @media (min-width: ${props => props.theme.breakpoints.tablet}) {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    img,
    source {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;

export default HeroOverlapStyles;
